// components/Authentication.tsx
import { ReactNode } from 'react';
import useAxiosInterceptor from '../hooks/useAxiosInterceptro';
import React from 'react';

interface AuthenticationProps {
    children: ReactNode;
}

const Authentication = ({ children }: AuthenticationProps) => {
    const isInterceptorSet = useAxiosInterceptor();

    if (!isInterceptorSet) {
        // Show a loading indicator or message until interceptor is set
        return <div>Loading...</div>; // You can replace this with your loading spinner
    }

    // Render children (app) once the interceptor is set up
    return <>{children}</>;
};

export default Authentication;
